import type { ChatPartRendererProps } from '@mui/x-chat/headless';

import { AgenticChatActivityWorkGroup } from './WorkGroup';
import { type AgenticChatActivityMessagePart, isAgenticChatActivityPart } from './isVisiblePart';

/** Keeps non-leading renderer instances from mounting the stateful work group. */
export function AgenticChatActivityGroup(
  props: ChatPartRendererProps<AgenticChatActivityMessagePart>
) {
  const { message, index } = props;
  if (isAgenticChatActivityPart(message.parts[index - 1])) {
    return null;
  }
  return <AgenticChatActivityWorkGroup {...props} />;
}
